type Props = {
    open: boolean;
    title: string;
    message: string;
    primaryLabel: string;
    onConfirm: () => void;
    onClose: () => void;
    submitting?: boolean;
    feedback?: { type: 'success' | 'error' | ''; text: string };
};

export function ConfirmModal({
    open,
    title,
    message,
    primaryLabel,
    onConfirm,
    onClose,
    submitting,
    feedback
}: Props) {
    if (!open) return null;

    return (
        <div className="modal" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <h2>{title}</h2>
                <form
                    onSubmit={e => {
                        e.preventDefault();
                        if (!submitting) onConfirm();
                    }}
                >
                    <div className="scroll-area">
                        <div className="form-field">
                            <div className="feedback-message">
                                {message}
                            </div>
                        </div>
                    </div>

                    {feedback?.text && (
                        <div className={`feedback-message ${feedback.type}`}>{feedback.text}</div>
                    )}

                    <div className="modal-actions">
                        <button
                            className={`btn-primary ${submitting ? 'loading' : ''}`}
                            type="submit"
                            disabled={submitting}
                        >
                            {submitting ? (
                                <>
                                    <span className="btn-label">Processing…</span>
                                </>
                            ) : (
                                <span className="btn-label">{primaryLabel}</span>
                            )}
                        </button>

                        <button
                            className="btn-secondary"
                            type="button"
                            onClick={onClose}
                            disabled={submitting}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
